import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import aduDistanceSetbackImage from '@/assets/adu-distance-setback.jpg';

const HowFarDoesADUHaveToBeFromHouseCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/adu-distance-from-house-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={aduDistanceSetbackImage} 
              alt="ADU setback distance measurements" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              How Far Does an ADU Have to Be from a House in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Discover mandatory setback distances between your ADU and primary house in California, ensuring compliance with local building codes.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                California ADU Setback Rules Explained
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California state law establishes minimum setback requirements for ADUs, typically requiring 4 feet from side and rear property lines. However, setbacks between ADUs and primary structures vary by local jurisdiction, with most requiring 6-10 feet of separation for fire safety and privacy considerations.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                City-specific Distance Guidelines
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Cities like Los Angeles require 5-foot setbacks for detached ADUs, while San Diego may require up to 10 feet depending on structure height. San Jose follows state minimums but adds requirements for windows facing neighboring properties. Each city's building department provides specific setback charts based on property size and zoning.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Tips for Optimizing ADU Placement
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Strategic ADU placement maximizes privacy while meeting setback requirements. Consider solar access, views, landscaping buffers, and utility connections when determining optimal distance from your main house. Professional site planning can help identify the best location while maintaining compliance with all distance requirements.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: What is the required setback for ADUs in California?</p>
                  <p>A: Typically 4–6 feet from property lines and existing structures, varying by city.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: Can setback rules for ADUs vary by city?</p>
                  <p>A: Yes, cities often impose additional local setbacks or exceptions.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default HowFarDoesADUHaveToBeFromHouseCalifornia;